import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';
import styles from 'sections/Resources/FreightTemplates/BillOfLading/components/SectionPurpose/SectionPurpose.module.scss';

const cn = classNames.bind(styles);

const SectionPurpose = (): ReactElement => {
  return (
    <section className={cn('purpose')}>
      <div className={cn('container')}>

        <div className={cn('purpose__section')}>

          <div className={cn('purpose__image-box')}>
            <picture>
              <source
                srcSet="
                /images/pages/Resources/FreightTemplates/sign-in.webp 1x,
                /images/pages/Resources/FreightTemplates/sign-in@2x.webp 2x
              "
                sizes="100vw"
              />
              <img
                className={cn('purpose__image')}
                src="/images/pages/Resources/FreightTemplates/sign-in.webp"
                alt="bill of lading"
              />
            </picture>
          </div>

          <div className={cn('purpose__content')}>
            <h2 className={cn('purpose__heading')}>
              <span>What is the purpose</span>{' '}
              <span>of a Bill of Lading?</span>
            </h2>
            <p className={cn('purpose__paragraph')}>
              The function of a Bill of Lading is straightforward yet multifaceted, 
              offering critical benefits that may not be immediately obvious. Essentially, 
              a BoL acts as a vital safeguard for the seller, shipper, and recipient 
              by providing a detailed record of when and where a shipment is in transit, 
              serving as both a receipt and a contract of carriage.
            </p>
            <p className={cn('purpose__paragraph')}>
              This document ensures clarity in the transfer of goods, protecting all parties 
              against potential lawsuits or disputes by documenting the terms of transport 
              and confirming the carrier’s receipt of the cargo.
            </p>
          </div>
          
        </div>

      </div>
    </section>
  );
};

export default SectionPurpose;